<!-- Plantas.vue -->
<template>
  <div
    class="bg-[var(--fundoForm)] w-full gap-2 p-4 rounded-md flex flex-col text-[var(--text)]"
  >
    <div class="w-full flex justify-between">
      <h3 class="text-[var(--titulo)]">
        Planta para o Local de Instalação: {{ localInstalacaoId }}
      </h3>
      <AppButton
        style="color: var(--icon)"
        class="self-end text-[var(--text)]"
        v-bind:visibility="true"
        left_icon="fa-regular fa-circle-xmark fa-xl"
        emitType="close"
        @close="close"
        :width="23"
        :height="23"
      />
    </div>

    <!-- Formulário de Adicionar Planta -->
    <form
      @submit.prevent="uploadPlant"
      class="flex flex-col items-left gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2 w-full"
    >
      <div class="w-full grid grid-cols-2 items-center gap-1">
        <label for="nome" class="text-[var(--text)]">Nome:</label>
        <input
          style="color: var(--text)"
          v-bind:style="{
            backgroundColor: !newPlant.nome
              ? 'var(--obrigatorio)'
              : 'var(--label)',
          }"
          v-model="newPlant.nome"
          id="nome"
          placeholder="Nome da Planta"
          required
          class="rounded-md p-1"
        />
      </div>

      <div class="w-full grid grid-cols-2 items-center gap-1">
        <label for="imagem" class="text-[var(--text)]">Imagem:</label>
        <input
          type="file"
          @change="handleFileUpload"
          accept="image/*"
          required
          class="rounded-md p-1"
        />
      </div>

      <div class="flex justify-end gap-2 mt-2">
        <button
          type="submit"
          class="px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          Criar Planta
        </button>

      </div>
    </form>

    <!-- Alternar entre Lista e Lista de Imagens -->
    <div class="mt-4 flex justify-end">
      <button
        @click="toggleViewMode"
        class="px-4 py-1 bg-green-600 rounded-lg shadow-lg hover:bg-green-700 text-white"
      >
        {{ viewMode !== "list" ? "Ver como Imagens" : "Ver como Lista" }}
      </button>
    </div>

    <!-- Lista de Plantas -->
    <div
      v-if="showPlantList"
      class="mt-4 p-2 rounded-md bg-[var(--fundoComponente)] flex-1 overflow-y-auto w-full"
    >
      <div v-if="plants.length > 0">
        <div v-if="viewMode !== 'list'">
          <!-- Visualização em Lista -->
          <AppTable
            :visibility="true"
            :show="true"
            :table_data="plants"
            table_title="Plantas Salvas"
            @row-clicked="selectPlant"
            @close="togglePlantList"
            :show_multiSelect="false"
          />
        </div>
        <div v-else>
          <!-- Visualização em Imagens -->
          <div class="flex overflow-x-auto gap-4 p-2 flex-wrap">
            <div
              v-for="plant in plants"
              :key="plant.id"
              class="flex flex-col items-center gap-2 group cursor-pointer flex-none w-1/5 max-w-[20%]"
              @mouseover="hover = plant.id"
              @mouseleave="hover = null"
              @click="selectPlant(plant)"
            >
              <img
                :src="plant.imagem_url"
                :alt="`Imagem de ${plant.nome}`"
                class="w-20 h-20 rounded-full object-cover transition-transform duration-300 group-hover:scale-110 shadow-lg"
              />
              <i
                class="text-center text-[var(--text)] group-hover:text-sky-400 transition-colors duration-300 not-italic"
                >{{ plant.nome }}</i
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center text-[var(--text)] no-documents-message bg-[var(--fundoComponente)]">
        Nenhuma planta encontrada.
      </div>
    </div>

    <!-- Modal para Visualização da Imagem -->
    <div
      v-if="selectedPlant"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="bg-white p-4 rounded-md">
        <h2 class="text-lg font-bold mb-2 text-[#ff9b05]">
          {{ selectedPlant.nome }}
        </h2>
        <div class="relative">
          <!-- MS estava plantas/imagem parece me que as classes soa iguais, mas a plantas/foto usa dirPlanta
           Nao percebo o conceito de coordenadas aqui-->
          <img :src="`${baseURL}/api/v1/plantas/foto/${selectedPlant.id}/`"
          alt="No Planta" class="max-w-full h-auto" @click="getCoordinates($event)" />
          <div v-if="selectedPlant.coordenadas" class="coordinate-marker" :style="getMarkerStyle(selectedPlant.coordenadas)">
            <i class="fa-solid fa-map-pin"></i>
          </div>
          <div
            v-if="coordinates"
            class="coordinate-marker"
            :style="getMarkerStyle(coordinates)"
          >
            <i class="fa-solid fa-map-pin"></i>
          </div>
        </div>
        <p v-if="coordinates" class="text-[#ff9b05] mt-2">
          Coordenadas: X: {{ coordinates.x }}, Y: {{ coordinates.y }}
        </p>
        <button
          v-if="coordinates"
          @click="saveCoordinates"
          class="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
        >
          Salvar Coordenadas
        </button>
        <button
          @click="closeModal"
          class="mt-4 bg-red-500 text-white px-4 py-2 rounded"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import { toast } from "vue3-toastify";
import AppButton from "@/components/updated/button.vue";

export default {
  name: "Plantas",
  components: {
    AppTable,
    AppButton,
  },
  props: {
    localInstalacaoId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
  this.fetchPlants();
},
  data() {
    return {
      newPlant: {
        nome: "",
        imagem: null,
      },
      plants: [],
      showPlantList: true,
      selectedPlant: null,
      viewMode: "list",
      coordinates: null,
      baseURL: process.env.VUE_APP_URL_BASE,
    };
  },
  methods: {

    handleFileUpload(event) {
      this.newPlant.imagem = event.target.files[0];
    },
    async uploadPlant() {
      const formData = new FormData();
      formData.append("nome", this.newPlant.nome);
      formData.append("localInstalacao_id", this.localInstalacaoId);

      try {
        const response = await axios.post(
          `${this.baseURL}/api/v1/plantas/`,
          formData
        );
        const plant = response.data;

        if (this.newPlant.imagem) {
          const imageFormData = new FormData();
          imageFormData.append("planta", this.newPlant.imagem);

          await axios.post(
            `${this.baseURL}/api/v1/plantas/foto/registrar/${plant.id}/`,
            imageFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }

        this.plants.push({
          id: plant.id,
          nome: plant.nome,
          imagem_url: `${this.baseURL}/api/v1/plantas/foto/${plant.id}/`,
          status: plant.status,
        });

        this.resetForm();
        this.showPlantList = true;

        toast.success("Planta criada com sucesso!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      } catch (error) {
        console.error("Erro ao criar planta:", error);
        toast.error("Erro ao criar planta. Tente novamente.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    },  

    async fetchPlants() {
      if (!this.localInstalacaoId) {
        console.error("localInstalacaoId não está definido.");
        return;
      }
      try {
        const response = await axios.get(
          `${this.baseURL}/api/v1/plantas/?localInstalacao_id=${this.localInstalacaoId}`
        );
        this.plants = response.data.map((plant) => ({
          id: plant.id,
          nome: plant.nome,
          coordenadas: plant.coordenadas,
          imagem_url: `${this.baseURL}/api/v1/plantas/foto/${plant.id}/`,
        }));
      } catch (error) {
        this.plants = [];
        console.error("Erro ao buscar plantas:", error);
      }
    },
    getCoordinates(event) {
      const img = event.target;
      const rect = img.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      this.coordinates = { x, y };
      console.log(`Coordenadas: X = ${x}, Y = ${y}`);
    },
    async saveCoordinates() {
      if (!this.coordinates || !this.selectedPlant) return;

      try {
        const response = await axios.post(
          `${this.baseURL}/api/v1/plantas/${this.selectedPlant.id}/coordenadas/`,
          {
            coordenadas: this.coordinates,
          }
        );
        toast.success("Coordenadas salvas com sucesso!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        this.selectedPlant.coordenadas = this.coordinates;
        this.coordinates = null;
        this.closeModal();
        this.fetchPlants();
      } catch (error) {
        console.error("Erro ao salvar coordenadas:", error);
        toast.error("Erro ao salvar coordenadas. Tente novamente.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      }
    },
    getMarkerStyle(coords) {
      if (!coords) return {};
      return {
        position: "absolute",
        left: `${coords.x}%`,
        top: `${coords.y}%`,
        transform: "translate(-50%, -100%)",
        color: "red",
        fontSize: "1.5em",
      };
    },
    togglePlantList() {
      this.showPlantList = !this.showPlantList;
      if (this.showPlantList) {
        this.fetchPlants();
      }
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === "list" ? "image" : "list";
    },
    selectPlant(plant) {
      this.selectedPlant = plant;
      this.coordinates = null;
    },
    closeModal() {
      this.selectedPlant = null;
      this.coordinates = null;
    },
    resetForm() {
      this.newPlant.nome = "";
      this.newPlant.imagem = null;
    },
    close() {
      this.$emit("close");
    },
  },
  created() {
    this.fetchPlants();
  },
};
</script>

<style scoped>
input[type="file"],
input[type="text"] {
  border-radius: 5px;
  padding: 0.5rem;
  border: 1px solid #cccccc;
  font-size: 0.875rem;
}
.no-documents-message {
  text-align: center;
  color: var(--icon);
  font-size: 0.875rem;
}
.fixed {
  position: fixed;
  z-index: 1000;
}
.bg-black {
  background-color: rgba(0, 0, 0, 0.5);
}
.coordinate-marker {
  position: absolute;
  transform: translate(-50%, -100%);
  color: red;
}
.relative {
  position: relative;
}

.flex::-webkit-scrollbar {
  height: 8px;
}

.flex::-webkit-scrollbar-thumb {
  background-color: rgba(93, 93, 152, 0.8);
  border-radius: 4px;
}

.flex::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Ajustar o espaçamento entre as imagens */
img {
  transition: transform 0.3s ease-in-out;
}
img:hover {
  transform: scale(1.1);
}

</style>
